module.exports = __webpack_public_path__ + "static/img/1045_big.c88b47d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1045_big.png
// module id = ryci
// module chunks = 1